/**
 * Ma'lumotli widgetlar uchun umumiy so'rov: `GET /api/widgets/data/<type>/` (doira va ruxsat backend'da,
 * apps/widgets/providers.py). Ko'rsatilgan real-time obyektlar o'zgarsa qayta so'raladi.
 */
import { useEffect } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryClient } from "@/lib/queryClient";
import { subscribeEvents } from "@/lib/realtime";

export const widgetDataKey = (type: string) => ["widgets", "data", type] as const;

export function useWidgetData<T>(type: string, params: Record<string, string | number | undefined>, entities: readonly string[], enabled = true) {
  const entityKey = entities.join(",");
  useEffect(() => {
    const set = new Set(entityKey.split(",").filter(Boolean));
    const off = subscribeEvents((ev) => {
      if (set.has(ev.entity)) void queryClient.invalidateQueries({ queryKey: widgetDataKey(type) });
    });
    return () => {
      off();
    };
  }, [type, entityKey]);
  return useQuery({
    queryKey: [...widgetDataKey(type), params],
    queryFn: () => api.get<T>(`/api/widgets/data/${type}/`, { query: params }),
    enabled,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
